import { render } from "./BlFormFieldMailrecipient.vue?vue&type=template&id=3aec35dd&scoped=true"
import script from "./BlFormFieldMailrecipient.vue?vue&type=script&lang=js"
export * from "./BlFormFieldMailrecipient.vue?vue&type=script&lang=js"

import "./BlFormFieldMailrecipient.vue?vue&type=style&index=0&id=3aec35dd&scoped=true&lang=scss"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aec35dd"]])

export default __exports__